import {
  IGeometryModel,
  MarkerModelBase,
} from '@types-custom/models/business/marker.model';

export interface IPropsRouteBusModel {
  id: string;
  name: string;
  date: string;
  rutas: string;
  markerPopupText: string;
  color: string;
  rgb: string;
}

export class RouteBusModel extends MarkerModelBase {
  static className = 'RouteBusModel';
  classProperties: IPropsRouteBusModel;

  constructor(
    props: IPropsRouteBusModel,
    geometry: IGeometryModel,
    lat?: number,
    lng?: number
  ) {
    super(geometry, RouteBusModel.className, lat, lng);
    this.classProperties = props;
    this.geometry = geometry;
  }
}
